'use client'

import * as RadioPrimitive from '@radix-ui/react-checkbox'
import * as React from 'react'

import { cn } from '../../lib'

type Props = React.ComponentProps<typeof RadioPrimitive.Root> & { color?: string }

const Radio = ({ className, color = '#7DDF40', ...props }: Props) => {
  const checkboxStyles = cn(
    // 기본 스타일
    'peer shrink-0 w-6 h-6 relative overflow-hidden',

    // 상태별 스타일
    'data-[state=unchecked]:text-gray-200',
    'data-[state=checked]:text-primary',

    // 포커스 및 비활성화 스타일
    'focus-visible:outline-none',
    'focus-visible:ring-1',
    'focus-visible:ring-ring',
    'disabled:cursor-not-allowed',
    'disabled:opacity-50',

    className,
  )

  return (
    <RadioPrimitive.Root className={checkboxStyles} {...props}>
      <RadioPrimitive.CheckboxIndicator forceMount className="left-0 top-0 absolute">
        {props.checked ? (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`text-[${color}]`}
          >
            <g id="Group 1410124303">
              <circle id="Ellipse 1806" cx="12" cy="12" r="12" fill="currentColor" />
              <circle id="Ellipse 1807" cx="12.0014" cy="12" r="5.45455" fill="white" />
            </g>
          </svg>
        ) : (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="Frame 1410124660">
              <g id="Group 1410124302">
                <circle id="Ellipse 1802" cx="12" cy="12" r="10.5" stroke="#D6D6D6" />
              </g>
            </g>
          </svg>
        )}
      </RadioPrimitive.CheckboxIndicator>
    </RadioPrimitive.Root>
  )
}

Radio.displayName = RadioPrimitive.Root.displayName

export default Radio
